import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { adminFieldLabelSx, adminFormControlSx } from '../../../../styles/adminComponentStyles';
import { formatPosTypeLabel } from '../../utils/posTypeLabels';

type AgentConfigurationPosTypeSelectProps = {
  selectedPosValue: string;
  posTypeMenuOpen: boolean;
  posTypeOptions: string[];
  posTypeLabel: string;
  hasSelectedOption: boolean;
  onOpenMenu: () => void;
  onCloseMenu: () => void;
  onSelect: (value: string) => void;
};

const AgentConfigurationPosTypeSelect: React.FC<AgentConfigurationPosTypeSelectProps> = ({
  selectedPosValue,
  posTypeMenuOpen,
  posTypeOptions,
  posTypeLabel,
  hasSelectedOption,
  onOpenMenu,
  onCloseMenu,
  onSelect,
}) => {
  return (
    <Box sx={{ mb: 2.5 }}>
      {/* <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
        <Typography sx={adminFieldLabelSx}>
          POS Type
        </Typography>
      </Box> */}

      <FormControl size="small" fullWidth sx={adminFormControlSx}>
        <InputLabel>POS Type</InputLabel>
        <Select
          value={selectedPosValue}
          open={posTypeMenuOpen}
          displayEmpty
          label="POS Type"
          onOpen={onOpenMenu}
          onClose={onCloseMenu}
          onChange={(e) => onSelect(String(e.target.value || ''))}
          renderValue={(value) => {
            const v = String(value || '').trim();
            return v ? formatPosTypeLabel(v) : 'Select POS Type';
          }}
        >
          {posTypeOptions.length > 0 ? (
            <>
              {!hasSelectedOption && selectedPosValue ? (
                <MenuItem value={selectedPosValue}>{formatPosTypeLabel(selectedPosValue)}</MenuItem>
              ) : null}
              {posTypeOptions.map((type) => (
                <MenuItem key={type} value={type} onClick={() => onSelect(type)}>
                  {formatPosTypeLabel(type)}
                </MenuItem>
              ))}
            </>
          ) : (
            <MenuItem value={selectedPosValue}>{formatPosTypeLabel(selectedPosValue) || posTypeLabel}</MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default React.memo(AgentConfigurationPosTypeSelect);
